import React from 'react'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'

const SeoHero = ({
  children,
  className = '',
  media = {},
  mediaClassName = '',
  mediaLayerClassName = '',
  scrimClassName = '',
  surface,
  ...headerProps
}) => {
  const {
    className: suppliedMediaClassName = '',
    priority: _priority,
    quality: _quality,
    sizes: _sizes,
    ...mediaProps
  } = media
  const resolvedMediaClassName = `${suppliedMediaClassName} ${mediaClassName}`.trim()
  const mediaNode = (
    <Media
      {...mediaProps}
      className={resolvedMediaClassName}
      policy={MEDIA_POLICY_KEYS.SEO_HERO}
    />
  )

  return (
    <header
      {...headerProps}
      className={className}
      data-msr-surface={surface}
    >
      {mediaLayerClassName
        ? <div className={mediaLayerClassName}>{mediaNode}</div>
        : mediaNode}
      {scrimClassName && <div className={scrimClassName} aria-hidden='true' />}
      {children}
    </header>
  )
}

export default SeoHero

